import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_globe } from '@fiverr-private/fit/icons';

const FLAG_SIZE = 20;

export const LazyFlag = ({ countryCode }, { logger }) => {
    const [flag, setFlag] = useState(null);

    useEffect(() => {
        const importFlag = async() => {
            try {
                const { [countryCode.toLowerCase()]: importedFlag } = await import(/* webpackChunkName: 'flags' */'@fiverr-private/fit/icons/flags');

                if (importedFlag) {
                    setFlag(importedFlag);
                }
            } catch (error) {
                error.description = `Failed to load the the seller country flag: ${countryCode.toLowerCase()}`;
                logger.error(error);
            }
        };

        importFlag();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countryCode]);

    return <Icon size={FLAG_SIZE} className="flag-icon">{flag || r_globe}</Icon>;
};

LazyFlag.propTypes = {
    countryCode: string
};

export default LazyFlag;
